module.exports = "<a href=# class=\"base-btn v2-btn purple-btn modal-auto-hide\">Close</a> <a href=# class=\"base-btn purple-btn add-products-btn\">Add Products</a>";


//////////////////
// WEBPACK FOOTER
// ./src/utilities/productsModalUtilities/html/modalOrderFooterBtns.html
// module id = 1456
// module chunks = 1